import List from '@mui/material/List';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import { useState } from 'react';
import { useContext } from 'react';
import { MahiContext } from '../../state/MahiContext';
import { postAdminUserRoles } from '../../../data/hikoAdmin';
import { hikoException } from '../../../utils/HikoAlert';
import { useEffect } from 'react';
import { UserReadOnly } from './UserReadOnly'
import { EditUserForm } from './EditUserForm';
import { patchAdminEditUser } from '../../../data/hikoAdmin';

export function UserRolesList({users, onUserEditComplete}) {

    console.log('UserRolesList started with users', users)
    const [theUsers, setTheUsers] = useState(users)
    const mahiContext = useContext(MahiContext)
    const [editUserId, setEditUserId] = useState(null)
    const [editedUser, setEditedUser] = useState(null) // {account, active, email, id, lastLoginDate, name, oid, phone, roles}

    useEffect(() => {
        setTheUsers(users)
    }, [users])

    const handleUserChanged = (userDetails) => {
      console.log(`handleUserChanged()`, {userDetails})
      setEditedUser(userDetails)
    }

    const handleEditClick = (userDetails) => {
      console.log(`handleEditClick()`, {userDetails})
      setEditUserId(userDetails.id)
    }

    const handleSaveClick = async () => {
      console.log(`handleSaveClick()`, {editedUser})

      if (!editedUser) {
        // Nothing changed?
        setEditUserId(null)
        return
      }

      let isSuccess = false;

      try {
        await Promise.all([
          // update user properties: name, email, phone, account
          await patchAdminEditUser(mahiContext, editedUser),
          // update user roles[]
          await postAdminUserRoles(mahiContext, editedUser.id, editedUser.roles)
        ])
        isSuccess = true;
      } catch (e) {
        hikoException('Error saving user', e)
      }

      if (isSuccess) {
          console.log('Saved user successfully')
          
          onUserEditComplete(editedUser)
      }

      setEditUserId(null)
    }

    const handleEditCancelClick = (userDetails) => {
      console.log(`handleEditCancelClick()`, {userDetails})
      setEditUserId(null)
    }

    return (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
        {
        theUsers?.map((thisUser) => {
            
            return (
              <Grid container spacing={2} key={thisUser.id}>
                <Grid item xs={6}>
                  <Box key={thisUser.id}>
                        {
                          editUserId === thisUser.id ? 
                          <EditUserForm userChanged={handleUserChanged} userDetails={thisUser} />
                          :
                          <UserReadOnly userDetails={thisUser}/>
                        }
                        
                      <Divider variant="inset" component="li" />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                <Box>
                    {
                      editUserId === thisUser.id ? 
                        <>
                          <Button variant="outlined" sx={{my:2.4, mx: 2}} onClick={() => { handleEditCancelClick(thisUser) }}>Cancel</Button>
                          <Button variant="contained" sx={{my:2.4, mx: 2}} onClick={handleSaveClick}>Save</Button>
                        </>
                        :
                        <>
                          <Button variant="outlined" sx={{my:2.4, mx: 2}} onClick={() => { handleEditClick(thisUser) }}>Edit</Button>
                        </>
                    }
                    
                    
                  </Box>
                </Grid>
              </Grid>
            )
        })
        }
        </List>
    )
}